import { render } from "./TalkBox.vue?vue&type=template&id=1aa64b43&scoped=true"
import script from "./TalkBox.vue?vue&type=script&lang=js"
export * from "./TalkBox.vue?vue&type=script&lang=js"

import "./TalkBox.vue?vue&type=style&index=0&id=1aa64b43&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa64b43"]])

export default __exports__